export default __webpack_public_path__ + "static/media/ev3.8284d007.png";